// import Blank from "./Blank";
import { useParams } from "react-router-dom";
import { useGetMessagesQuery, messagesApi } from "../../../features/messages/messagesApi";
import Error from "../../ui/Error";
import ChatHead from "./ChatHead";
import Message from "./Message";
import Options from "./Options";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
export default function ChatBody() {
    
    const { user } = useSelector((state) => state.auth) || {};
    const { email } = user || {};
    const { id } = useParams();
    const {
        data,
        isLoading,
        isError,
        error,
    } = useGetMessagesQuery({id,email});
    const { data:messages, totalCount } = data || {};

    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const dispatch = useDispatch();

    const fetchMore = () => {
        console.log('fetched')
        setPage((prevPage) => prevPage + 1);
    };

    useEffect(() => {
        if (page > 1) {
            dispatch(
                messagesApi.endpoints.getMoreMessages.initiate({
                    id,
                    email,
                    page,
                })
            );
        }
    }, [page, id, dispatch]);

    useEffect(() => {
        if (totalCount > 0) {
            const more = Math.ceil(totalCount / Number(process.env.REACT_APP_MESSAGES_PER_PAGE) ) > page;
            setHasMore(more);
        }
    }, [totalCount, page]);
 
    // decide what to render
    let content = null;

    if (isLoading) {
        content = <div>Loading...</div>;
    } else if (!isLoading && isError) {
        content = (
            <div>
                <Error message={error?.data} />
            </div>
        );
    } else if (!isLoading && !isError && messages?.length === 0) {
        content = <div>No messages found!</div>;
    } else if (!isLoading && !isError && messages?.length > 0) {
        content = (
            <>
                <ChatHead message={messages[0]} />
                <div  id="scrollableDiv" className="relative w-full h-[calc(100vh_-_197px)] p-6 overflow-y-auto flex flex-col-reverse" 
                      style={{
                        height: window.innerHeight - 700
                        }}
                >
                    <ul className="space-y-2">
                      {messages?.length > 0 &&
                        <InfiniteScroll
                            dataLength={messages.length}
                            next={fetchMore}
                            hasMore={hasMore}
                            style={{ display: 'flex', flexDirection: 'column-reverse'}}
                            // height={'calc(100vh - 197px)'}
                            inverse={true} 
                            loader={<h4>Loading . . .</h4>}
                            scrollableTarget="scrollableDiv"
                        >
                            {messages.slice().sort((a, b) => b.timestamp - a.timestamp).map((message) => {
                                    const {
                                        message: lastMessage,
                                        id,
                                        sender,
                                    } = message || {};

                                    const justify =
                                        sender.email !== email ? "start" : "end";

                                    return (
                                        <Message
                                            key={id}
                                            justify={justify}
                                            message={lastMessage}
                                        />
                                    );
                                })}
                            </InfiniteScroll>
                      }  

                    </ul>
                </div>
                <Options info={messages[0]} />
            </>
        );
    }

    return (
        <div className="w-full lg:col-span-2 lg:block">
            <div className="w-full grid">{content}</div>
            {/* <div className="w-full grid conversation-row-grid">{content}</div> */}
        </div>
    );
}
